<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page024">
<div class="jstfy" id="page024_1">OLIVE PASTE</div>
<div class="jstfy" id="page024_2">P<span class="small1">âte d</span>’O<span class="small1">live</span></div>
<div class="jstfy" id="page024_3">TIME REQUIRED:</div>
<div class="jstfy" id="page024_4">1.</div>
<div class="jstfy" id="page024_4a"><span class="page024_4a"> Coarsely chop the olives and capers and combine in a blending</span></div>
<div class="jstfy" id="page024_5">10 minutes</div>
<div class="jstfy" id="page024_6">beaker with the mustard. Purée with a hand-held blender while</div>
<div class="jstfy" id="page024_7">gradually incorporating the oil.</div>
<div class="jstfy" id="page024_8">70 g pitted black olives</div>
<div class="jstfy" id="page024_9">2.</div>
<div class="jstfy" id="page024_9a"><span class="page024_9a">Season with salt and pepper.</span></div>
<div class="jstfy" id="page024_10">20 g capers</div>
<div class="jstfy" id="page024_11">Tip:</div>
<div class="jstfy" id="page024_11a"><span class="page024_11a"> Olives are green before they ripen, later darkening and</span></div>
<div class="jstfy" id="page024_12">1 tsp Dijon mustard</div>
<div class="jstfy" id="page024_13">turning black. The tastiest are the small, black Niçoise olives.</div>
<div class="jstfy" id="page024_14">3 tbsp olive oil</div>
<div class="jstfy" id="page024_15">Salt, pepper</div>
<div class="jstfy" id="page024_16">B<span class="pagen">asics</span></div>
<div class="jstfy" id="page024_0">24</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_024.vue?07606c48